export default "__VITE_PUBLIC_ASSET__5d6786df__"